import h from "../utils/htm";

export default async element => { // 'social-links'
	element.innerHTML = [
		{name:'facebook',url:'http://www.facebook.com/sharer/sharer.php?u=URL'},
		{name:'twitter',url:'http://twitter.com/intent/tweet/?text=TITLE&url=URL'}
	].map( ({name,url}) => h('a href="'+url.replace('URL',encodeURIComponent(location.href)).replace('TITLE',encodeURIComponent(document.title))+'" target="_blank" class="icon-'+name+'"')).join('');
};